$(document).ready(function () {
    const base_url = $("meta[name='baseUrl']").attr('content');

    $(".sign-out").click(function (event) {
        Swal.fire({
            icon: "warning",
            title: "แจ้งเตือน",
            text: "ยืนยันการออกจากระบบ",
            confirmButtonText: "ตกลง",
            cancelButtonText: "ปิด",
            showCancelButton: true,
            customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-active-light",
            },
        }).then(async(result) => {
            if (result.isConfirmed) {
				try {
					await axios.post('home/logout',{})
				} catch (error) {
					Swal.close();
					Swal.fire('เกิดข้อผิดพลาด',error.response.data.message,'error');
					console.error(error)
					return;
				}
                window.location = base_url + "login";
            }
        });
    });
});
